// ~/helpers/reportUtils.js
import moment from 'moment';

import { generateReport } from '~/helpers/reportUtils'; // já existe

/**
 * Função genérica para exportar relatórios em PDF/Excel
 * @param {Object} config - configurações do relatório
 * @param {string} config.endpoint - endpoint da API (ex: 'postos', 'clientes', etc.)
 * @param {string} config.formato - 'PDF' ou 'EXCEL'
 * @param {Array<string>} config.fields - lista de campos a exportar
 * @param {Object} config.headers - chave/valor para renomear colunas
 * @param {Object} config.redux - estado redux da tabela (params, filtros, etc.)
 * @param {string} [config.orderfield='id'] - campo de ordenação
 * @param {string} [config.ordination='asc'] - direção de ordenação
 * @param {string} [config.title='Relatório'] - título do relatório
 * @param {Object} [config.substituirValores={}] - objeto para substituir valores específicos no relatório (ex: { status: { 'A': 'Ativo', 'I': 'Inativo' } })
 * @param {Object} [config.ignorarFormatacao={}] - campos que não devem ser formatados (ex: { idcliente: true })
 */
export async function handleExportGeneric({
  endpoint,
  formato,
  fields,
  headers,
  redux,
  orderfield,
  ordination,
  ignorarFormatacao = {},
  substituirValores = {},
  title = 'Relatório',
  compactQuery = false,
}) {
  try {
    const fieldlistString = fields.join(',');

    const wherefield = redux?.params?.wherefield || [];
    const valuewherefield = redux?.params?.valuewherefield || [];

    // Combina os dois arrays campo: valor
    const filtrosCompletos = wherefield
      .map((campo, i) => {
        const valor = valuewherefield[i];
        if (valor === undefined || valor === '') return null;

        // Usa o nome amigável, se existir, senão o nome original
        const nomeCampo = headers[campo] || campo;

        return `${nomeCampo}: ${valor}`;
      })
      .filter((v) => v !== null);

    const filtrosTexto =
      filtrosCompletos.length > 0
        ? `- Filtros: ${filtrosCompletos.join(' | ')}`
        : '';

    const textoPesquisa = `${title} - ${moment().format(
      'DD/MM/YYYY HH:mm:ss'
    )} ${filtrosTexto}`;

    const reportRequestParams = {
      fieldlist: fieldlistString,
      wherefield: redux?.params?.wherefield || [],
      typewherefield: redux?.params?.typewherefield || [],
      valuewherefield: redux?.params?.valuewherefield || [],
      filteruser: false,
      orderfield,
      ordination,
      relatorio: {
        formato,
        tituloRelatorio: title,
        substituirHeader: headers,
        substituirValores: JSON.stringify(substituirValores || {}),
        ignorarFormatacao: JSON.stringify(ignorarFormatacao || {}),
        textoPesquisa,
        custom: true,
      },
    };
    console.log('Payload enviado para API:', reportRequestParams);
    await generateReport({
      endpoint,
      params: reportRequestParams,
      compactQuery,
    });
  } catch (err) {
    console.error('Erro ao exportar relatório:', err);
  }
}
